export function fmtNum(n: number): string {
  if (!isFinite(n) || isNaN(n)) return '—';
  return Math.round(n).toLocaleString('ja-JP');
}

// 切り上げで整数化（1人当たり給与等で使用）
export function fmtCeil(n: number): string {
  if (!isFinite(n) || isNaN(n)) return '—';
  return Math.ceil(n).toLocaleString('ja-JP');
}

export function fmtPct(n: number, digits = 2): string {
  if (!isFinite(n) || isNaN(n)) return '—';
  return n.toFixed(digits);
}

export function fmtSigned(n: number): string {
  if (!isFinite(n) || isNaN(n)) return '—';
  return (n >= 0 ? '+' : '') + Math.round(n).toLocaleString('ja-JP');
}
